import React from "react";
import { useLocation } from "react-router-dom";

export default function EmailEnviado(){

  const location = useLocation();

  const email = location.state?.email;


  return (

    <div className="
      min-h-screen
      bg-background
      flex
      items-center
      justify-center
      px-6
    ">

      <div className="
        bg-white
        p-8
        rounded-card
        shadow-md
        text-center
        max-w-md
      ">

        <h1 className="
          text-h3
          font-bold
          text-text-primary
        ">
          Email enviado
        </h1>


        <p className="
          mt-4
          text-text-secondary
        ">
          Enviamos um link de recuperação para:
        </p>


        <p className="
          mt-2
          font-semibold
        ">
          {email}
        </p>


        <p className="
          mt-4
          text-caption
        ">
          Verifique sua caixa de entrada e também a pasta de spam.
        </p>


      </div>

    </div>

  );

}